import {
  LOADING,
  ACCOUNTINFO,
  ACCOUNTINFO_ERROR,
  SUBSCRIPTIONACCOUNTINFO,
  SUBSCRIPTIONACCOUNTINFO_ERROR,
  EMPTY_ERROR_COMMON_OBJ,
  UPDATEACCOUNTINFO,
  MAILALERTINFO,
  MAILALERTINFO_ERROR,
  USAGEACCOUNTINFO,
  USAGEACCOUNTINFO_ERROR,
  UPDATEPASSWORDINFO,
  UPDATEPASSWORDINFO_ERROR,
  USAGELEADACCOUNTINFO,
  USAGELEADACCOUNTINFO_ERROR,
  RESETPASSWORDINFO,
  RESETPASSWORDINFO_ERROR,
  SUBSCRIPTIONS,
  NOTIFICATIONS,
} from "../actionType/commonType";

const initialState = {
  loading: true,
  accountInfo: {},
  errObj: {},
  subscriptionaccountInfo: {},
  updateaccountInfo: {},
  mailAlertInfo: {},
  usageaccountInfo: {},
  updatePasswordInfo: {},
  usageleadcount: "",
  resetPasswordInfo: {},
  subscriptions: [],
  notifications: [],
};

const CommonReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOADING:
      return { ...state, loading: payload };
    case ACCOUNTINFO:
      return { ...state, accountInfo: payload };
    case NOTIFICATIONS:
      return { ...state, notifications: payload };
    case UPDATEACCOUNTINFO:
      return { ...state, updateaccountInfo: payload };
    case MAILALERTINFO:
      return { ...state, mailAlertInfo: payload };
    case SUBSCRIPTIONS:
      return { ...state, subscriptions: payload };
    case MAILALERTINFO_ERROR:
      return { ...state, errObj: { ...state.errObj, ...payload } };
    case ACCOUNTINFO_ERROR:
      return { ...state, errObj: { ...state.errObj, ...payload } };
    case SUBSCRIPTIONACCOUNTINFO:
      return { ...state, subscriptionaccountInfo: payload };
    case USAGEACCOUNTINFO:
      return { ...state, usageaccountInfo: payload };
    case UPDATEPASSWORDINFO:
      return { ...state, updatePasswordInfo: payload };
    case USAGELEADACCOUNTINFO:
      return { ...state, usageleadcount: payload };
    case RESETPASSWORDINFO:
      return { ...state, resetPasswordInfo: payload };
    case RESETPASSWORDINFO_ERROR:
      return { ...state, resetPasswordInfo: payload };
    case USAGELEADACCOUNTINFO_ERROR:
      return { ...state, errObj: { ...state.errObj, ...payload } };
    case UPDATEPASSWORDINFO_ERROR:
      return { ...state, errObj: { ...state.errObj, ...payload } };
    case USAGEACCOUNTINFO_ERROR:
      return { ...state, errObj: { ...state.errObj, ...payload } };
    case SUBSCRIPTIONACCOUNTINFO_ERROR:
      return { ...state, errObj: { ...state.errObj, ...payload } };
    case EMPTY_ERROR_COMMON_OBJ:
      return { ...state, errObj: payload };
    default:
      return state;
  }
};

export default CommonReducer;
